import React from "react";
import { withStyles } from "@material-ui/core";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import { theme } from "@themes";

export const AntTabs = withStyles({
  root: {
    zIndex: "1",
  },
  indicator: {
    backgroundColor: theme.tabs.border,
  },
})(Tabs);

export const AntTab = withStyles(( MUITheme ) => ({
  root: {
    textTransform: "none",
    width: 200,
    marginRight: MUITheme.spacing(0),
    color: theme.button.primary,
    "&:hover": {
      color: theme.button.primary,
      fontWeight: MUITheme.typography.fontWeightBold,
      opacity: 1,
    },
    "&$selected": {
      color: theme.button.primary,
      fontWeight: MUITheme.typography.fontWeightBold,
      opacity: 1,
    },
    "&:focus": {
      color: theme.button.primary,
      fontWeight: MUITheme.typography.fontWeightBold,
      opacity: 1,
    },
  },
  selected: {
    color: theme.button.primary,
    fontWeight: MUITheme.typography.fontWeightBold,
  },
}))((props) => <Tab style={props.valueTabs === 0 ? {color: theme.button.primary, fontWeight: "600"} : {color: theme.button.primary}} disableRipple {...props} />);
